const template=`
<widget-status></widget-status>
<generic-highchart chart-data="chartData" drill="drillDown()" ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></generic-highchart>`;
export default template;
